import '@platsoft/grape-ui';
import '@platsoft/grape-ui-bs3';
import '@platsoft/grape-ui-login';
import '@platsoft/grape-ui-dashboard';
import '@platsoft/grape-ui-user-account';
import '@platsoft/grape-ui-processes';
import '@platsoft/grape-ui-components';
import '@platsoft/grape-ui-upload-bar';
import 'grape-ui-input-dialog';
import '@platsoft/grape-ui-reports';
import '@platsoft/grape-ui-forms';


/* Import CSS */
import '@platsoft/grape-ui/dist/grape-ui-bundle.css';
import '@platsoft/grape-ui-bs3/dist/grape-ui-bs3.css';
import '@platsoft/grape-ui-login/dist/grape-ui-login/grape-ui-login.css';
import '../static/custom-bulma.sass';
import '@platsoft/grape-ui-reports/dist/grape-reports/grape-reports.css';
import '@platsoft/grape-ui-forms/dist/grape-ui-forms/grape-ui-forms.css';

/* Application/Library entry-point */
import './lib/PSCM.js';

//import caches from './caches/index.js';
import dialogs from './dialogs/index.js';
import pages from './pages/index.js';

/* Import navbar */
import navbar from '../static/navbar.json';
/* Plugin */
import Plugin from './lib/Plugin.js';



/* Define default routes */
const default_routes = {
	"guest": "#/grape-ui/login",
	"account.owner": "#/installations",
	"account.internal": "#/admin/accounts_installations"
};

$(window.user_nav_item = ()=>(window.Grape && window.Grape.currentSession && window.Grape.currentSession.user && window.Grape.currentSession.user.username) ? `<a href="#/grape-ui/my-account"><span class="fa fa-user"></span> ${window.Grape.currentSession.user.username}</a>`: '');

Grape.utils.register_pages(pages);
Grape.utils.register_dialogs(dialogs);

$(document).ready(() => {
	/* Setup app */
	Grape.config.navbar = navbar;
	Grape.config.default_routes = default_routes;
	Grape.plugins.register(Plugin);

	/* Start app */
	Grape.init();
});
